module.exports = __webpack_public_path__ + "static/media/court.58c00efb.jpeg";